<template>
  <!-- Specifically dont check for the presense of "board" since we might be the backlog  -->
  <v-expansion-panel v-if="project && (projectBoards.length >= 0) && (projectStatuses.length > 0) && (projectMembers.length > 0)"
     v-model="panel"
    >
    <v-expansion-panel-content :class="expansionBackground">

      <template v-slot:header>
        <v-layout row class="subheading" >
          <v-flex v-if="board">
            <v-icon color="white">dashboard</v-icon>
            <router-link
              class="white--text pl-2"
              :to="{ path: board.links.show_uri }"
              >
              {{board.attributes.name}}
              <span class="pl-4 caption">{{ticketBreakdown}}</span>
            </router-link>
          </v-flex>

          <v-flex v-if="backlog === true" class="white--text">
            <v-icon color="white" class="pr-3">access_time</v-icon>
            Backlog of open tickets
            <span class="pl-4 caption">{{ticketBreakdown}}</span>
          </v-flex>
          <v-flex v-if="!board && !backlog" class="white--text">
            <v-icon color="white" class="pr-3">view_list</v-icon>
            All Tickets
            <span class="pl-4 caption">{{ticketBreakdown}}</span>
          </v-flex>

          <div v-if="board && localBoard && !localBoard.archived">
            <v-flex shrink class="due-date" slot="header" v-if="permit.canEditBoard(board)">
              <v-menu
                ref="menu"
                :close-on-content-click="true"
                v-model="menu"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                @click.native.stop
                >
                <v-text-field slot="activator"
                  v-model="localBoard.due_on"
                  label="Due on"
                  prepend-icon="event"
                  readonly
                  dark
                  clearable
                  @click:clear="updateBoard()"
                ></v-text-field>
                <v-date-picker
                  v-model="localBoard.due_on"
                  color="primary"
                  no-title
                  scrollable
                  @change="updateBoard()"
                  show-current
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    color="primary"
                    @click="menu = false"
                    >
                    Cancel
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="white--text text-xs-right mr-3" v-else>
              {{dueDate}}
            </v-flex>
          </div>

          <v-flex class="white--text text-xs-right mr-3" v-if="board && localBoard && localBoard.archived">
            Archived
          </v-flex>
        </v-layout>
      </template>

      <v-card>
        <v-layout justify-end row wrap>
          <v-flex shrink class="mr-3" xs6 md4 lg3>
            <v-text-field v-model="pagination.search"
              append-icon="search"
              :label="(board && 'Search this board') || 'Search the backlog'"
              single-line
              inline-flex
              hint="Use & and | to join search terms. Search specific fields with tag:, status:, assigned:"
            ></v-text-field>
          </v-flex>
          <v-flex shrink v-if="board && localBoard">
            <v-tooltip bottom color="#fff" v-if="permit.canEditBoard(board) && watch">
              <v-btn icon slot="activator" @click="unsetWatch()">
                <v-icon small class="mr-1">visibility_off</v-icon>
              </v-btn>
              <span class="black--text">Ignore</span>
            </v-tooltip>

            <v-tooltip bottom color="#fff" v-if="permit.canEditBoard(board) && !watch">
              <v-btn icon slot="activator" @click="setWatch()">
                <v-icon small class="mr-1">visibility</v-icon>
              </v-btn>
              <span class="black--text">Watch</span>
            </v-tooltip>

            <v-tooltip bottom color="#fff" v-if="permit.canEditBoard(board) && localBoard.archived">
              <v-btn icon slot="activator" @click="unarchive">
                <v-icon small class="mr-1">unarchive</v-icon>
              </v-btn>
              <span class="black--text">Activate</span>
            </v-tooltip>

            <v-tooltip bottom color="#fff" v-if="permit.canEditBoard(board) && !localBoard.archived">
              <v-btn icon slot="activator" @click="archive">
                <v-icon small class="mr-1">archive</v-icon>
              </v-btn>
              <span class="black--text">Archive</span>
            </v-tooltip>

            <v-tooltip bottom color="#fff" v-if="permit.canDeleteBoard(board)">
              <v-btn icon slot="activator" @click="deleteBoard = !deleteBoard">
                <v-icon small class="mr-1">delete</v-icon>
              </v-btn>
              <span class="black--text">Delete</span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headers"
          :items="tickets"
          :total-items="totalTickets"
          :loading="loading"
          :must-sort="true"
          :pagination.sync="pagination"
          no-data-text="Loading tickets..."
          >
          <template slot="items"
            slot-scope="props"
            >
            <td class="text-xs-left link">
              <v-chip
                outline
                label
                small
                >
                {{props.item.attributes.sequential_id}}
              </v-chip>
            </td>
            <td class="text-xs-center link">
              <v-icon v-show="props.item.attributes.priority == 'low' || props.item.attributes.priority == null"
                @click="setPriority(props.item, 'medium')"
                >
                star_outline
              </v-icon>
              <v-icon v-show="props.item.attributes.priority == 'medium'"
                @click="setPriority(props.item, 'high')"
                >
                star_half
              </v-icon>
              <v-icon v-show="props.item.attributes.priority == 'high'"
                @click="setPriority(props.item, 'low')"
                >
                star
              </v-icon>
            </td>
            <td class="text-xs-left link">
              <router-link v-if="board"
                :to="{ path: props.item.links.project_show_uri + '?boardId=' + board.id }">
                {{ props.item.attributes.title }}
              </router-link>
              <router-link v-else
                :to="{ path: props.item.links.project_show_uri }">
                {{ props.item.attributes.title }}
              </router-link>
            </td>
            <td class="text-xs-center font-weight-bold"
              :sstyle="{'background-color': statusForTicket(props.item).color }"
              >
              <v-chip
                :color="statusForTicket(props.item).color"
                outline
                label
                >
                {{ statusForTicket(props.item).name }}
              </v-chip>
            </td>
            <td class="text-xs-center font-weight-bold">
              {{props.item.attributes.created_at | formatDate}}
            </td>
            <td class="text-xs-center font-weight-bold">
              {{props.item.attributes.updated_at | formatDateAgo}}
            </td>
            <td class="text-xs-center font-weight-bold">
              <v-avatar v-if="memberThumbUrl(memberForTicket(props.item))" size=24>
                <img :src="memberThumbUrl(memberForTicket(props.item))" alt="Avatar">
              </v-avatar>
              {{ memberForTicket(props.item).name }}
            </td>
            <td>
              <v-select v-if="permit.canEditTicket(props.item)"
                v-model="props.item.board_ids"
                :items="projectBoards.map((pBrd) => { return pBrd.attributes })"
                @change="updateTicketPlacements(props.item)"
                item-text="name"
                item-value="id"
                label="Place on board(s)"
                multiple
                chips
              ></v-select>
              <div v-else>
                <span v-for="(brd, idx) in projectBoards.map((pBrd) => { return pBrd.attributes }).sort((a, b) => a.name.localeCompare(b.name))" :key="idx">
                  <v-chip disabled small>{{brd.name}}</v-chip>
                </span>
              </div>
            </td>
          </template>
          <v-alert slot="no-results"
            :value="true"
            color="error"
            icon="warning"
            >
            Your search for "{{ pagination.search }}" found no results.
          </v-alert>
        </v-data-table>
        <div v-if="!board" class="pb-4">
          <!-- Last line to provide padding for the favbuttons -->
        </div>
      </v-card>

      <v-dialog
        v-if="board"
        v-model="deleteBoard"
        max-width="500px"
        persistent
        lazy
        :fullscreen="$vuetify.breakpoint.xsOnly"
        >
        <boardDelete :project="project" :board="board" ></boardDelete>
      </v-dialog>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  import { debounce } from 'debounce'
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'
  import permissions from '@/utilities/permissions'

  import boardService from '@/services/board'
  import ticketService from '@/services/ticket'
  import commentService from '@/services/comment'
  import placementService from '@/services/placement'
  import watchService from '@/services/watch'

  import boardDelete from '@/components/board/_delete'

  export default {
    name: 'project-board',

    components: {
      boardDelete
    },

    props: ['board', 'project', 'projectBoards', 'projectStatuses', 'projectMembers', 'backlog'],

    data () {
      return {
        auth: authentication,
        permit: permissions,
        headers: [
          { text: 'Number', value: 'sequential_id', align: 'center', width: '5%' },
          { text: 'Priority', value: 'last_comment.priority', align: 'center', width: '2%', sortable: false },
          { text: 'Description', value: 'title', align: 'left', width: '33%' },
          { text: 'Status', value: 'status.name', align: 'center', width: '5%' },
          { text: 'Created', value: 'created_at', align: 'center', width: '10%' },
          { text: 'Updated', value: 'updated_at', align: 'center', width: '10%' },
          { text: 'Assigned', value: 'assignee.name', align: 'center', width: '10%', sortable: false },
          { text: 'Boards', value: 'boards', align: 'center', width: '30%', sortable: false }
        ],
        pagination: {
          rowsPerPage: parseInt(authentication.preferences().page_size) || 5,
          sortBy: (authentication.preferences().ticket_sort_by || 'sequential_id'),
          descending: !(authentication.preferences().ticket_sort_order === 'asc'), // This is to deal with the preference being unset
          search: ''
        },
        tickets: [],
        totalTickets: 0,
        placements: [],
        users: [], // stored copied of users we already fetched at need
        localBoard: null, // used for mutating board when we edit the date
        menu: false,
        deleteBoard: false,
        watch: null,
        panel: null,
        loading: true
      }
    },

    watch: {
      pagination: {
        handler (val) {
          this.reloadTickets()
        },
        deep: true
      }
    },

    mounted () {
      if (this.board) {
        this.loadBoardPlacements()
        this.loadBoardWatches()
        this.localBoard = Object.assign({}, this.board.attributes)
      } else {
        this.panel = 0
      }

      EventBus.$on('board-deleted', (payload) => {
        // we dont do anything if the user cancelled the delete, processing the deletion is done in the project show
        this.deleteBoard = false
      })

      EventBus.$on('ticket-created', (payload) => {
        if (payload) {
          payload = this.setTicketBoardIds(payload)
          this.manageTicket(payload)
        }
      })

      EventBus.$on('ticket-updated', (payload) => {
        if (payload) {
          payload = this.setTicketBoardIds(payload)
          this.manageTicket(payload)
        }
      })

      if (this.board || this.backlog) {
        this.loadTickets()
        EventBus.$on('board-search', (payload) => {
          this.pagination.search = payload
          this.$nextTick(() => {
            this.loadTickets()
          })
        })
      }
    },

    computed: {
      expansionBackground () {
        if (this.localBoard && this.localBoard.due_on) {
          // here we can be due or overdue
          let boardDate = new Date(this.localBoard.due_on)
          let currentDate = new Date()
          if (boardDate < currentDate) {
            return 'v-expansion-panel-expired'
          } else {
            return 'v-expansion-panel-due'
          }
        // we have no date to work with, so we just do nothing
        } else {
          return 'v-expansion-panel-backlog'
        }
      },

      ticketBreakdown () {
        let phrase = '( '
        let total = this.totalTickets
        if (total === 0) {
          phrase += 'no tickets'
        } else if (total === 1) {
          phrase += '1 ticket'
        } else {
          phrase += total + ' tickets'
        }
        phrase += ' )'
        return phrase
      },

      dueDate () {
        if (this.localBoard && this.localBoard.due_on) {
          return `due ${this.$options.filters.formatDateAgo(this.localBoard.due_on)}`
        }
      }
    },

    methods: {
      loadTickets () {
        this.loading = true

        if (this.board) {
          ticketService.boardIndex(
            (data, total) => {
              data.forEach((ticket) => {
                ticket = this.setTicketBoardIds(ticket)
              })
              this.tickets = data
              this.totalTickets = total
              this.loading = false
              if (this.totalTickets > 0) {
                EventBus.$emit('board-search-match', this.board.id)
              }
            },
            (err) => {
              console.log(err)
            },
            this.board.id,
            this.pagination
          )
        } else {
          ticketService.projectIndex(
            (data, total) => {
              data.forEach((ticket) => {
                ticket = this.setTicketBoardIds(ticket)
              })

              this.tickets = data
              this.totalTickets = total
              this.loading = false
            },
            (err) => {
              console.log(err)
            },
            this.project.id,
            this.pagination,
            this.backlog
          )
        }
      },

      reloadTickets: debounce(function () {
        this.loadTickets()
      }, 500),

      loadBoardWatches () {
        watchService.boardIndex(
          (data) => {
            this.watch = data.find(watch => this.auth.isCurrentUser(watch.relationships.user.data.id) && (watch.relationships.watchable.data.type === 'board'))
          },
          (err) => {
            console.log(err)
          },
          this.board.id
        )
      },

      updateBoard () {
        boardService.update(
          (data) => {
            this.localBoard = Object.assign({}, data.attributes)
          },
          (err) => {
            console.log(err)
          },
          this.localBoard
        )
      },

      updateTicket (ticket) {
        ticketService.update(
          (data) => {
            // we dont directly manage the ticket here, we need to publish the changes, the ticket
            // may have moved to another board
            // if the ticket is not supposed to be here anymore, just remove it
            this.refilterTickets()
            EventBus.$emit('ticket-updated', data)
          },
          (err) => {
            console.log(err)
          },
          ticket.attributes
        )
      },

      createTicketComment (ticket, placement, present) {
        let ticketTagList = ticket.attributes.tag_list
        let statusId = ticket.relationships.status.data.id

        let message = ''
        if (present) {
          message = 'Assigned to board ' + placement.attributes.board_name
        } else {
          message = 'Removed from board ' + placement.attributes.board_name
        }
        return commentService.ticketCreate(
          (data) => {
            // nothing to do here ?
          },
          (err) => {
            console.log(err)
          },
          ticket.id,
          {
            status_id: statusId,
            tag_list: ticketTagList,
            message: message
            // NOTE: when we drag a ticket, we post a new comment and we need to preserve the tags
            // the tickets most recent tags are conveniently returned with the ticket
            // itself, even though they reside on the comments
          }
        )
      },

      updateTicketPlacements (ticket) {
        // get all the placements for this ticket
        placementService.ticketIndex(
          (data) => {
            // now for each placement delete it if we dont want it anymore
            data.forEach((plc) => {
              if (!ticket.board_ids.includes(parseInt(plc.relationships.board.data.id))) {
                // the placement is not on the list of ones we want
                placementService.ticketDelete(
                  () => {
                    // placement removed (use the one from the loop)
                    this.createTicketComment(ticket, plc, false)
                    this.updateTicket(ticket)
                  },
                  (err) => {
                    console.log(err)
                  },
                  ticket.id, plc.id
                )
              }
            })
            // now for all the boards I want a placement on, create it if its not there
            ticket.board_ids.forEach((brdId) => {
              // do we have a placement for it?
              if (!data.find(pl => parseInt(pl.relationships.board.data.id) === parseInt(brdId))) {
                placementService.ticketCreate(
                  (data) => {
                    // placement added
                    this.createTicketComment(ticket, data, true)
                    this.updateTicket(ticket)
                  },
                  (err) => {
                    console.log(err)
                  },
                  ticket.id,
                  // -1 adds it to the bottom of the list
                  {board_id: brdId, position: -1}
                )
              }
            })
          },
          (err) => {
            console.log(err)
          },
          ticket.id
        )
      },

      manageTicket (ticket) {
        // we are either a board this ticket belongs to, or we are the backlog and it belongs nowhere
        if ((this.board && ticket.board_ids.includes(parseInt(this.board.id))) || (!this.board && (ticket.board_ids.length == 0))) {
          // we dont touch the ticket if it's not meant for us
          let index = this.tickets.findIndex(item => item.id == ticket.id)
          if (~index) {
            // we know about this ticket, already, update our copy
            this.tickets[index] = ticket
          } else {
            // we dont know about this ticket, add it to our list (at the front)
            this.tickets.unshift(ticket)
            this.totalTickets += 1
          }
        }
        this.refilterTickets()
      },

      statusForTicket (ticket) {
        if (ticket.relationships.status.data) {
          let status = this.projectStatuses.find(item => parseInt(item.id) === parseInt(ticket.relationships.status.data.id))
          return status.attributes
        } else {
          // I've seen some broken tickets before so we just need to guard against that
          return {color: '#000', name: 'unknown'}
        }
      },

      memberForTicket (ticket) {
        if (ticket.relationships.assignee.data) {
          let member = this.projectMembers.find(item => parseInt(item.relationships.user.data.id) === parseInt(ticket.relationships.assignee.data.id))
          if (member) {
            return member.attributes
          }
        }
        return {name: 'not assigned'}
      },

      setTicketBoardIds (ticket) {
        ticket.board_ids = ticket.relationships.boards.data.map(rel => parseInt(rel.id))
        return ticket
      },

      loadBoardPlacements () {
        placementService.boardIndex(
          (data) => {
            this.placements = data
          },
          (err) => {
            console.log(err)
          },
          this.board.id
        )
      },

      placementForTicket (ticket) {
        let placement = this.placements.find(item => parseInt(item.relationships.ticket.data.id) === parseInt(ticket.id))
        if (placement) {
          return placement.attributes
        }
        return {position: 0}
      },

      refilterTickets () {
        // make sure we only show tickets that belong to us, this ticket might not now, "but it used to could"
        if (this.board) {
          // we need to update the placements we know about
          this.loadBoardPlacements()
          // if we are a board (and not the backlog)
          this.tickets = this.tickets.filter(item => item.board_ids.includes(parseInt(this.board.id)))
        } else if (this.backlog) {
          // we are the backlog, there is no  board and we only take board-less tickets
          this.tickets = this.tickets.filter(item => item.board_ids.length == 0)
        } else {
          // this is the master list of all tickets, so we basically just refresh the list
          this.tickets = Object.assign([], this.tickets) // this.tickets.filter(item => true)
        }
      },

      setWatch () {
        watchService.boardCreate(
          (data) => {
            this.watch = data
          },
          (err) => {
            console.log(err)
          },
          this.board.id,
          {user_id: this.auth.userId()}
        )
      },

      unsetWatch () {
        watchService.boardDelete(
          (data) => {
            this.watch = null
          },
          (err) => {
            console.log(err)
          },
          this.board.id,
          this.watch.id
        )
      },

      setPriority: debounce((ticket, level) => {
        return commentService.ticketCreate(
          (data) => {
            ticket.attributes.priority = data.attributes.priority
          },
          (err) => {
            console.log(err)
          },
          ticket.id,
          {priority: level}
        )
      }, 250),

      archive () {
        this.localBoard.archived = true
        this.updateBoard()
      },

      unarchive () {
        this.localBoard.archived = false
        this.updateBoard()
      },

      memberThumbUrl (membership) {
        if (membership && membership.links && membership.links.avatar_uri) {
          return (process.env.API_URL + membership.links.avatar_uri)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /* due boards are green*/
  .v-expansion-panel-due{
    background-color: #2b7d1f !important;
  }

  /* go red when overdue */
  .v-expansion-panel-expired{
    background-color: #E53935 !important;
  }

  /* normal/closed are darker blue*/
  .v-expansion-panel-backlog {
    background-color: #0155a8 !important;
  }

  @media screen and (min-width: 600px) {
    .sticky-element{
      position: sticky;
      position: -webkit-sticky;
      top: 65px;
      z-index: 5;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/project/_board.vue